<template>
  <div v-if="!loading">
    <h2>Inicio</h2>

    <div class="card mt-2">
      <p class="font-medium text-lg">
        {{ user.admin.name }} {{ user.admin.last_name }}
      </p>
      <p class="text-lg">{{ user.email }}</p>
      <p class="mt-6">
        Rol:
        <span class="font-medium">{{
          user.admin.is_super ? "Súper Admin" : user.role.name
        }}</span>
      </p>
      <p>Permisos</p>
      <p v-if="user.admin.is_super" class="font-medium">Todos</p>
      <div v-else>
        <p
          v-for="permission in user.role.permissions"
          :key="permission.id"
          class="font-medium"
        >
          - {{ permission.display_name }}
        </p>
      </div>

      <p class="mt-6 text-lg">
        Clientes Activos:
        <span class="font-medium">{{ activeClients }}</span>
      </p>
    </div>
  </div>

  <div v-else class="flex w-full h-full items-center">
    <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
  </div>
</template>

<script>
import api from "@/api";
import { mapState } from "vuex";
export default {
  name: "Home",

  data() {
    return {
      activeClients: null,
      petCount: null,
      loading: false,
    };
  },

  computed: {
    ...mapState({
      user: "user",
    }),
  },

  created() {
    this.$store.commit("setSelectedTab", "home");

    this.loadClients();
  },

  methods: {
    async loadClients() {
      this.loading = true;

      try {
        const response = await api.dashboard.getStats();
        this.activeClients = response.active_clients;
        this.petCount = response.pet_count;
      } catch (error) {
        // Dashboard stats endpoint may not exist yet — fail silently
        this.activeClients = '-';
      }

      this.loading = false;
    },

    formatDate(datetime) {
      if (!datetime) {
        return "-";
      }

      const parts = datetime.split("-");
      const formattedDate = `${parts[1]}-${parts[2]}-${parts[0]}`;

      const date = new Date(formattedDate);

      return date.toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
};
</script>